import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { Deeplink, DeeplinkURL } from '@root/entities/deeplinking'
import { joinedInviteCodeAtom } from '@root/entities/referral'
import { DEMO_MODE, PlatformUtil } from '@root/shared'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { twitterRedirectRequestAction } from './twitter-requests'

import type { TwitterAuthAction } from '../model'

//If action is not provided, it's either login or register
export const redirectToTwitterAction = action(
  async (ctx, action?: TwitterAuthAction) => {
    if (DEMO_MODE) {
      window.location.replace(
        `${window.location.origin}/twitter-auth?authCode=twitter_demo_code&state=${action ?? ''}`,
      )
      return
    }

    const inviteCode = ctx.get(joinedInviteCodeAtom)

    const redirectUrl = DeeplinkURL.getURLFor(
      'TwitterAuth',
      // authCode and state will be generated by twitter
      [
        new Deeplink.TwitterAuth({
          authCode: undefined,
          state: undefined,
        }),
      ],
    ).toString()

    const result = await ctx.schedule(() =>
      twitterRedirectRequestAction(ctx, {
        redirectUrl,
        action,
        referralCode: inviteCode,
      }),
    )

    if (Result.isFailure(result)) {
      showSnackbarAction(ctx, {
        text: i18next.t('common.something-went-wrong'),
        intent: 'error',
      })
      return
    }

    PlatformUtil.openLink(result.success.authUrl)
  },
  'redirectToTwitterAction',
)
